import {Button, MenuItem, Stack} from "@mui/material";
import {useContext, useEffect, useRef, useState} from "react";
import ErrorHandlingForm from "../../../../components/formValidation/ErrorHandlingForm";
import CustomSelect from "../../../../components/formValidation/CustomSelect";
import Typography from "@mui/material/Typography";
import {validateRequired} from "../../../../components/formValidation/validators";
import useCallDataApi from "../../../../hooks/data";
import {formatTime, getDayOfWeek} from "../../../../utils/misc";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DinoDialog from "../../../../components/Dialog";
import OccurrenceData from "./OccurrenceData";
import AuthContext from "../../../../context/AuthContext";
import {hasPermission} from "../../../../permissions/hasPermission";

const Reoccurring = ({serviceId}) => {
    const {getData, postData} = useCallDataApi('service')
    const {user} = useContext(AuthContext)
    const canEditService = hasPermission(user, 'service', 'edit')
    const [occurrences, setOccurrences] = useState([])
    const [loading, setLoading] = useState(true)
    const [current, setCurrent] = useState(-1)
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [createDialogOpen, setCreateDialogOpen] = useState(false)
    const occurrenceRef = useRef(null)

    const removeOccurrence = () => {
        postData(`${serviceId}/delete_occurrence`, {occurrence_id: current}).then(data => {
            setOccurrences(occurrences.filter((o) => o.id !== current))
        })
    }

    const addOccurrence = (occurrenceData) => {
        postData(`${serviceId}/add_occurrence`, occurrenceData).then(data => {
            setOccurrences([...occurrences, data])
        })
    }

    useEffect(() => {
        getData(`${serviceId}/get_occurrences`)
            .then(data => setOccurrences(data)).finally(() => setLoading(false))
    }, [])


    return <Stack>
        <Stack p={1}>
            <Typography variant='body2' color='#536B74'>
                A szolgáltatás rendszeresen ismétlődő időpontokban érhető el.
            </Typography>
        </Stack>
        {occurrences?.map((occurrence, idx) => <Stack key={occurrence?.id} p={1}>
            <Stack direction='row' justifyContent='space-between'>
                <Stack>
                    <Typography variant='h6'>Ismétlődés #{idx + 1}</Typography>
                    <Typography color='#536B74'
                                variant='body2'>Minden {getDayOfWeek(occurrence.day_of_week)} ekkor: {formatTime(occurrence.time)}</Typography>
                </Stack>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <IconButton disabled={!canEditService} onClick={() => {
                        setCurrent(occurrence.id)
                        setDeleteDialogOpen(true)
                    }}
                                sx={{
                                    border: '2px solid',
                                    borderColor: 'primary.main',
                                    background: '#fff',
                                    color: 'primary.main',
                                    // ":hover": {
                                    //     backgroundColor: 'primary.20',
                                    // }
                                }}><DeleteRoundedIcon/>
                    </IconButton>
                </Stack>
            </Stack>
        </Stack>)}
        <Stack direction='row' mt={2}>
            <Button
                variant='contained'
                disabled={!canEditService}
                onClick={() => setCreateDialogOpen(true)}
                endIcon={<AddCircleIcon/>}>
                Új ismétlődés hozzáadása
            </Button>
        </Stack>

        <DinoDialog open={deleteDialogOpen}
                    title='Ismétlődés törlése'
                    subtitle='Ha kitörlöd az ismétlődést a kliensek számára nem fog megjelenni a foglalási folyamat során! Az eddig leadott foglalások nem fognak tölődni.'
                    handleClose={() => setDeleteDialogOpen(false)}>
            <Stack direction='row' justifyContent='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setDeleteDialogOpen(false)}>Mégsem</Button>
                <Button variant='contained' onClick={() => {
                    setDeleteDialogOpen(false)
                    removeOccurrence()
                }} endIcon={<DeleteRoundedIcon/>}>Törlés</Button>
            </Stack>
        </DinoDialog>

        <DinoDialog open={createDialogOpen}
                    title='Ismétlődés törlése'
                    subtitle='Ha kitörlöd az ismétlődést a kliensek számára nem fog megjelenni a foglalási folyamat során! Az eddig leadott foglalások nem fognak tölődni.'
                    handleClose={() => setCreateDialogOpen(false)}>
            <OccurrenceData reference={occurrenceRef} obj={null}/>
            <Stack direction='row' justifyContent='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setCreateDialogOpen(false)}>Mégsem</Button>
                <Button variant='contained' onClick={() => {
                    let data = occurrenceRef.current.getData()
                    if (data) {
                        const date = new Date(data.time);
                        data = {
                            ...data, time: date.toLocaleTimeString("hu-HU", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false
                            })
                        }
                        addOccurrence(data)
                        setCreateDialogOpen(false)
                    }

                }} endIcon={<DeleteRoundedIcon/>}>Hozzáadás</Button>
            </Stack>
        </DinoDialog>
    </Stack>
}

const Fixed = ({serviceId, fixed_start}) => {
    return <Stack>
        <Stack p={1}>
            <Typography variant='body2' color='#536B74'>
                A szolgáltatás egy konkrét, előre meghatározott időpontban érhető el.
            </Typography>
        </Stack>
        <Stack p={1}>
            <Stack direction='row' justifyContent='space-between'>
                <Stack>
                    <Typography variant='h6'>Esemény</Typography>
                    <Typography color='#536B74' variant='body2'>
                        {fixed_start ? new Date(fixed_start).toLocaleString('hu-HU') : 'Nincs beállítva'}
                    </Typography>
                </Stack>
                {fixed_start && (
                    <Stack direction='row' spacing={1} alignItems='center'>
                        <IconButton onClick={() => {
                            // Edit functionality
                        }}
                                    sx={{
                                        border: '2px solid',
                                        borderColor: 'primary.main',
                                        background: '#fff',
                                        color: 'primary.main',
                                    }}><EditRoundedIcon/>
                        </IconButton>
                        <IconButton onClick={() => {
                            // Delete functionality
                        }}
                                    sx={{
                                        border: '2px solid',
                                        borderColor: 'primary.main',
                                        background: '#fff',
                                        color: 'primary.main',
                                    }}><DeleteRoundedIcon/>
                        </IconButton>
                    </Stack>
                )}
            </Stack>
        </Stack>
        <Stack direction='row' mt={2}>
            <Button
                variant='contained'
                // onClick={() => setFixedDialog(true)}
                endIcon={<AddCircleIcon/>}>
                Új esemény hozzáadása
            </Button>
        </Stack>
    </Stack>
}

const Dynamic = () => {
    return <Stack p={1}>
        <Typography variant='body2' color='#536B74'>
            A szolgáltatás dinamikusan elérhető a kiválasztott kollégák munkaidejében.
        </Typography>
    </Stack>
}

const Occurrence = ({reference, data, setData}) => {
    const [errors, setErrors] = useState({
        occurrence_type: false,
    });

    const validators = {
        occurrence_type: [validateRequired],
    }

    const occurrenceMap = {
        // 'fixed': <Fixed serviceId={data.id} fixed_start={data.fixed_start}/>,
        'recurring': <Reoccurring serviceId={data.id}/>,
        'dynamic': <Dynamic/>
    }

    return <ErrorHandlingForm data={data} setData={setData} errors={errors} setErrors={setErrors}
                              validators={validators} reference={reference}>
        <Stack spacing={1} marginTop={2} marginBottom={2}>
            <Typography variant='caption' color='primary.main'>
                Mikor legyen elérhető a szolgáltatás?
            </Typography>
            <CustomSelect
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='occurrence_type'
                variant='standard'
            >
                <MenuItem value='dynamic'>Dinamikus</MenuItem>
                {/*<MenuItem value='fixed'>Esemény</MenuItem>*/}
                <MenuItem value='recurring'>Ismétlődő</MenuItem>
            </CustomSelect>
            {occurrenceMap[data.occurrence_type]}
        </Stack>
    </ErrorHandlingForm>
}

export default Occurrence